import request from '@/utils/request'

//获取权限类型
export function getDemandType(data) {
  return request({
    url: 'sysDemandType/list',
    method: 'post',
    data,
  })
}

//获取需求类型
export function getAuthType(data) {
  return request({
    url: 'sysAuthType/list',
    method: 'post',
    data,
  })
}

//获取需求列表
export function getDemandList(data) {
  return request({
    url: 'sysDemand/list',
    method: 'post',
    data,
  })
}

// 抢单
export function insertGrabbing(data) {
  return request({
    url: 'sysOrderGrabbing/insert',
    method: 'post',
    data: data,
  })
}

// 确认 抢单
export function confirmGrabbing(data) {
  return request({
    url: 'sysOrderGrabbing/confirm',
    method: 'post',
    data,
  })
}

// 取消 订单
export function cancelGrabbing(data) {
  return request({
    url: 'sysOrderGrabbing/cancel',
    method: 'post',
    data,
  })
}

export function OrderGrabbing(data) {
  return request({
    url: 'sysOrderGrabbing/list',
    method: 'post',
    data,
  })
}

// 抢单人历史评价
export function commentGrabbing(data) {
  return request({
    url: 'sysOrderGrabbingComment/list',
    method: 'post',
    data,
  })
}

// 评价
export function insertComment(data) {
  return request({
    url: 'sysOrderGrabbingComment/insert',
    method: 'post',
    data,
  })
}

// 权限类型
export function listTableCategory1(data) {
  return request({
    url: 'sysAuthType/list',
    method: 'post',
    data,
  })
}

// 需求类型
export function listTableCategory2(data) {
  return request({
    url: 'sysDemandType/list',
    method: 'post',
    data,
  })
}

// 新增需求
export function addDemane(data) {
  return request({
    url: 'sysDemand/insert',
    method: 'post',
    data: data,
  })
}

// 判断用户身份
export function getAuth(data) {
  return request({
    url: 'sysOrderGrabbing/getAuth',
    method: 'post',
    data: data,
  })
}

// 删除 需求
export function deleteDemand(data) {
  return request({
    url: `/sysDemand/delete/?id=${data}`,
    method: 'get',
  })
}
